import type { Integration } from '@interfaces/integrations';
import { IntegrationTypes } from '@interfaces/integrations';

const isBankingIntegration = (integration: Integration): boolean =>
  integration?.type === IntegrationTypes.BANKING;

export const findIntegrationCondition = (options?: {
  applicableIntegration?: string;
}) => {
  if (options?.applicableIntegration) {
    return (integration: Integration) =>
      isBankingIntegration(integration) &&
      integration?.id === options.applicableIntegration;
  }

  return isBankingIntegration;
};
